
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/courses/web-programming",
      function () {
        return require("private-next-pages/next/courses/web-programming.tsx");
      }
    ]);
  